import { Auction } from '@/api';
import { toStripeAmount } from '@/app/utils/stripe';
import Button from '@/components/general/Button';
import { StripePromise, StripeOptions } from '@/helpers/StripePromise';
import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';
import i18next from 'i18next';
import React, { useState } from 'react';
import AuctionPricePromotion from '@/contexts/AuctionPricePromotion';
import useItemContext from '@/hooks/useItemContext';
import useAuth from '@/contexts/AuthContext';
import useAuction from '@/hooks/useAuction';
import If, { ElseIf } from '@/components/util/IF';
import { BuyNowButton } from '../../ProductBid/BuyNowButton';

type Props = {
    hasAuctionFlag: boolean;
    donationAmount?: string;
};

const ProductEcomBuyNowButton = ({ hasAuctionFlag, donationAmount }: Props) => {
    const { item: product } = useItemContext();
    const { user } = useAuth();
    const { auction, hasWonAuction, isOwner } = useAuction(product, undefined, true);

    const [isBuying, setIsBuying] = useState<boolean>(false);

    return (
        <If condition={hasAuctionFlag && auction?.type === Auction.TypeEnum.BuyNow}>
            <If condition={[auction?.status === Auction.StatusEnum.Open, auction?.buy_now_amount, product]}>
                <div className="space-y-4">
                    <AuctionPricePromotion auction={auction}>{({ amount, promotedAmount }) => {
                        return (
                            <Elements
                                stripe={StripePromise}
                                options={
                                    {
                                        ...StripeOptions,
                                        mode: 'payment',
                                        amount: toStripeAmount(donationAmount || promotedAmount || amount),
                                        capture_method: 'automatic',
                                        currency: 'usd',
                                        loader: 'always',
                                        appearance: {
                                            ...StripeOptions.appearance,
                                            variables: {
                                                ...StripeOptions.appearance?.variables,
                                                borderRadius: '99999px',
                                                colorPrimary: '#001F30'
                                            }
                                        }
                                    } as StripeElementsOptions
                                }>
                                <BuyNowButton donationAmount={donationAmount} auction={auction!} item={product!} loading={isBuying} setLoading={setIsBuying} />
                            </Elements>
                        );
                    }}
                    </AuctionPricePromotion>
                    {user && (
                        <Button
                            fullWidth
                            className="whitespace-nowrap"
                            href={{ pathname: `/item/${product?.slug}/buy`, query: { donationAmount } }}>{i18next.t('button-text.buy-now')}
                        </Button>
                    )}
                </div>
                <ElseIf condition={auction?.has_sold && !(hasWonAuction || isOwner)}>
                    <Button
                        fullWidth
                        className="whitespace-nowrap"
                        disabled>{i18next.t('button-text.sold')}test
                    </Button>
                </ElseIf>
            </If>
        </If>
    );
};

export default ProductEcomBuyNowButton;
